"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewLoginAs extends new_item_1.default {
    constructor(newLoginAs) {
        super();
        this.username = newLoginAs.username;
        this.user = newLoginAs.user;
        this.token = newLoginAs.token;
        this.mfaRequired = newLoginAs.mfaRequired;
        this.expires = newLoginAs.expires;
        this.scope = newLoginAs.scope;
        this.tokenType = newLoginAs.tokenType;
    }
}
exports.default = NewLoginAs;
//# sourceMappingURL=new-loginAs.js.map